// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5f6b7a1a","513":"3fa5e718"}[chunkId] + ".chunk.js";
};